import { useEffect } from "react";
import { useSelector } from "react-redux";
import { BASENAME } from "../../../utils/basename";

const MessaggioPersonalizzazione = ({
  areaStampa,
  superficieLogo,
  productFormati,
}) => {
  const genericheTranslation = useSelector(
    (state) => state.translations.generiche
  );

  useEffect(() => {
    return () => {
      console.log("MessaggioPersonalizzazione");
      console.log(productFormati);
    };
  }, [productFormati]);

  return (
    <div className="w-full relative flex justify-center items-center bg-ribola-chelsea-cucumber text-white text-sm font-opensanssemibold mt-8 px-3 py-2">
      <img
        src={BASENAME + "/images/customize.svg"}
        width="39"
        height="39"
        className=""
        alt="Personalizzazione"
      />
      <div className="p-2 text-xs sm:text-sm lg:text-xs 3xl:text-sm">
        <span>{genericheTranslation.messaggiopersonalizzazione.itemName}</span>
        <br />
        <span>
          {genericheTranslation.messaggioformatiprevisti.itemName}{" "}
          {productFormati}
        </span>
      </div>
    </div>
  );
};

export default MessaggioPersonalizzazione;
